module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_112-5816d14e5ff2b2140016e6728b5704dc.png";